export const FEATURE_FLAG_KEYS = {} as const;

export type FeatureFlagKey =
    (typeof FEATURE_FLAG_KEYS)[keyof typeof FEATURE_FLAG_KEYS];

export interface FeatureFlagDef {
    key: FeatureFlagKey;
    label: string;
    description: string;
}

export const FEATURE_FLAGS: FeatureFlagDef[] = [];

export const ALL_FEATURE_FLAG_KEYS: string[] = FEATURE_FLAGS.map((f) => f.key);

export const isFeatureFlagKey = (value: unknown): value is FeatureFlagKey =>
    typeof value === 'string' && ALL_FEATURE_FLAG_KEYS.includes(value);
